// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"26a08fc9","298":"711d3b0d","357":"4c644509","453":"0128cdb9","620":"6ffef8db","631":"f6e2fa15","835":"caa169fa","844":"c0db9b3c","971":"b5f951a6"}[chunkId] + ".chunk.js";
};